import React, { useEffect, useState } from 'react';
import { Label, Button } from 'reactstrap';
import './phone-content.scss';

import { GetPhoneService } from 'services';
import { PhoneCard, ModalPhone, PanelTopWrapper } from 'components';

export function PhoneContent({ idStore }) {

  const URL_FIRST_REGISTER = "new";
  const [phones, setPhones] = useState([]);
  const [active, setActive] = useState(false);
  const [update, setUpdate] = useState([]);
  const [phoneEdit, setPhoneEdit] = useState();
  const [visibility, setVisibility] = useState("hide");

  useEffect(() => {

    const visibility = idStore !== URL_FIRST_REGISTER ? "show" : "hide";
    setVisibility(visibility);

    const getPhones = async () => {
      GetPhoneService(idStore).then((phones) => {
        setPhones(phones);
      })
    }

    if (idStore !== URL_FIRST_REGISTER) getPhones()

  }, [idStore, update]);

  const triggerEdit = (idPhone) => {
    setActive(true);
    setPhoneEdit(idPhone);
  }

  const toggleModal = () => {
    setActive(!active);
  }

  const updateContacts = () => {
    setUpdate(!update);
  }

  const renderPhones = (contacts = []) => {
    return contacts.map((contact) => {
      return (
        <PhoneCard contact={contact.phoneNumber} id={contact.id} update={updateContacts} openModalPhone={triggerEdit} />
      )
    })
  }

  return (
    <div className={`phone-content ${visibility}`}>
      <Label>Telefone</Label>
      <PanelTopWrapper id={"phone-card"} padding={"py-0"}>
        {renderPhones(phones)}
      </PanelTopWrapper>

      <ModalPhone
        modalClass={'modal-phone'}
        idStore={idStore}
        update={updateContacts}
        openModal={active}
        toggleModalPhone={toggleModal}
        phoneEdit={phoneEdit}
      />
      <Button color="primary" onClick={() => triggerEdit(URL_FIRST_REGISTER)}>{"+ Adicionar Telefone"}</Button>
    </div>
  );
}
